import { render } from "./editDrug.vue?vue&type=template&id=2a42c35e&scoped=true"
import script from "./editDrug.vue?vue&type=script&lang=js"
export * from "./editDrug.vue?vue&type=script&lang=js"

import "./editDrug.vue?vue&type=style&index=0&id=2a42c35e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a42c35e"

export default script